import React from 'react';
import './Helpers/Functions';
import LayoutManager from './Components/Layout/LayoutManager';
import store from './Store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import * as moment from 'moment';
import 'moment/locale/pt-br';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";

moment.locale('pt-br');

const App = () => {
   const [queryClient] = React.useState(
      () =>
         new QueryClient({
            defaultOptions: {
               queries: {
                  refetchOnWindowFocus: false,
                  refetchOnMount: false,
                  refetchOnReconnect: false,
                  retry: false,
                  staleTime: 5 * 1000,
               },
            },
         })
   );
   return (
      <Sentry.ErrorBoundary
         fallback={({ error, componentStack, resetError }) => (
            <React.Fragment>
               <div>Parece que você encontrou um erro, iremos corrigir o mais rápido possível!</div>
               <button
                  onClick={() => {
                     resetError();
                  }}
               >
                  Clique aqui para recarregar
               </button>
            </React.Fragment>
         )}
         showDialog
      >
         <QueryClientProvider client={queryClient}>
            <Router>
               <Provider store={store}>
                  <LayoutManager />
               </Provider>
            </Router>
             {/*<ReactQueryDevtools initialIsOpen={false} />*/}
         </QueryClientProvider>
      </Sentry.ErrorBoundary>
   );
};

App.propTypes = {};

export default App;
